import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';

export const initObject = {
  id: undefined,
  title: "",
  provinceId: 0,
  provinceTitle: "",
  isDeleted: false
};

export const columns = [
  {
    dataField: "title",
    text: "عنوان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },

];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان",
        label: "عنوان",
        rowIdx: 1,
        class: "col-lg-4"
      },
      {
        name: "provinceId",
        type: "option",
        component: (props) =>
          <SelectObjectsField api="api/province"
            reduxState="provinces"
            sname="provinceId"
            label="استان" {...props} />,
        placeholder: "استان",
        label: "استان",
        rowIdx: 2,
        class: "col-lg-4"
      },

    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "provinceId",
    lable: "استان",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/province"
        reduxState="provinces"
        sname="provinceId"
        {...props} />
  },
  {
    name: "title",
    lable: "MODULES.GENERAL.SEARCH",
    type: "text",
    list: [],
  },

];

export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    title: "",
    provinceId: 0
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, title, provinceId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by provinceId
  filter.provinceId = provinceId !== "" ? +provinceId : 0;

  // Filter by all fields
  filter.title = title;
  if (title) {
    filter.title = title;
  }
  newQueryParams.filter = filter;

  let whereClause = ""
  const whereClauseParameters = [];
  var idx = 0;

  if (title !== "" && title !== undefined && idx === 0) {
    whereClause = `title.contains(@${idx})`
    whereClauseParameters.push(title)
    idx++;
  }
  else if (title !== "" && title !== undefined && idx > 0) {
    whereClause = whereClause + ` and title.contains(@${idx})`
    whereClauseParameters.push(title)
    idx++;
  }


  if (filter.provinceId > 0 && idx === 0) {
    whereClause = `provinceId=@${idx}`
    whereClauseParameters.push(filter.provinceId)
    idx++;
  }
  else if (filter.provinceId > 0 && idx > 0) {
    whereClause = whereClause + ` and provinceId=@${idx}`
    whereClauseParameters.push(filter.provinceId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};

// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  provinceId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),

});

